import router from './router'
import useCategoryStore from './store'
import CategoryMessages from './localization'

export default {
  router,
  useCategoryStore,
  localization: CategoryMessages,
}
